import { InputLabel, styled } from '@mui/material';

export const StyledLabel = styled(InputLabel)<{ reservationInput?: boolean; requiredInput?: boolean }>(
	() => `
	text-align:start;
	&.MuiInputLabel-root {
		font-size: 0.875rem;
		line-height: 1.25rem;
	}
	`
);
